import React, { useState } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import { message, Spin } from "antd";
import Bridge from "../constants/Bridge";
import Strings from "../constants/Strings";

const ChangePassword = () => {
  // state list
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  // on toogle password
  const handleChange = (e) => {
    if (e.target.name == "oldPassword") {
      setOldPassword(e.target.value);
    } else if (e.target.name == "newPassword") {
      setNewPassword(e.target.value);
    } else if (e.target.name == "confirmPassword") {
      setConfirmPassword(e.target.value);
    }
  };
  // change password
  const pleaseChangePassword = () => {
    setLoading(true);
    if (oldPassword == "") {
      message.warning("Please enter old password first.");
      setLoading(false);
      return;
    } else if (newPassword == "") {
      message.warning("Please enter old password.");
      setLoading(false);
      return;
    } else if (confirmPassword == "") {
      message.warning("Please enter confirm password.");
      setLoading(false);
      return;
    }
    if (newPassword.length < 8) {
      message.warning(
        "New Password length must be greater than or equal to 8 characters."
      );
      setLoading(false);
      return;
    }
    if (newPassword != confirmPassword) {
      message.warning(
        "Both the Password and Confirm Password fields value must be matched."
      );
      setLoading(false);
      return;
    }
    let params = {
      old_password: oldPassword,
      new_password: newPassword,
      c_user_id: localStorage.getItem("consortia_user_id"),
    };
    Bridge.changePassword
      .change(params)
      .then(function (response) {
        setLoading(false);
        if (response.data.status == "1") {
          message.success(response.data.message);
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          message.error(response.data.message);
        }
      })
      .catch(function (error) {
        message.error("Please try again!!");
      });
  };
  // toggle password
  const togglePassword = (num) => {
    if (num == "1") {
      setOldPasswordType(oldPasswordType == "password" ? "text" : "password");
    } else if (num == "2") {
      setNewPasswordType(newPasswordType == "password" ? "text" : "password");
    } else if (num == "3") {
      setConfirmPasswordType(
        confirmPasswordType == "password" ? "text" : "password"
      );
    }
  };
  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10 main-section add-user top-space main_content_right_side "
          style={{ marginLeft: "auto", alignItems: "center", paddingTop: 0 }}
        >
          <div className="wrapper clearfix" style={{ paddingTop: 0 }}>
            <div className="multisteps-form">
              <div className="row">
                <div className="col-12 col-lg-6 pl-0">
                  <div className="wizard-content-form">
                    <div
                      className="wizard-form-field"
                      style={{ margin: "17px 0 14px 14px" }}
                    >
                      <h3 className="user-profile-heading">
                        {Strings.changePassword}
                      </h3>
                      <br />
                      <br />
                      <Spin spinning={loading} delay={500}>
                        <div className="wizard-form-input position-relative form-group has-float-label">
                          <input
                            type={oldPasswordType}
                            className="form-control"
                            name="oldPassword"
                            placeholder="Old Password"
                            value={oldPassword}
                            onChange={handleChange}
                          />
                          <label>Old Password</label>
                          <div
                            className="togglePassword"
                            onClick={() => togglePassword("1")}
                          >
                            {oldPasswordType == "password" ? (
                              <i className="fas fa-eye-slash"></i>
                            ) : (
                              <i className="fas fa-eye"></i>
                            )}
                          </div>
                        </div>
                        <div className="wizard-form-input position-relative form-group has-float-label">
                          <input
                            type={newPasswordType}
                            className="form-control"
                            name="newPassword"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={handleChange}
                          />
                          <label>New Password</label>
                          <div
                            className="togglePassword"
                            onClick={() => togglePassword("2")}
                          >
                            {newPasswordType == "password" ? (
                              <i className="fas fa-eye-slash"></i>
                            ) : (
                              <i className="fas fa-eye"></i>
                            )}
                          </div>
                        </div>
                        <div className="wizard-form-input position-relative form-group has-float-label">
                          <input
                            type={confirmPasswordType}
                            className="form-control"
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={handleChange}
                          />
                          <label>Confirm Password</label>
                          <div
                            className="togglePassword"
                            onClick={() => togglePassword("3")}
                          >
                            {confirmPasswordType == "password" ? (
                              <i className="fas fa-eye-slash"></i>
                            ) : (
                              <i className="fas fa-eye"></i>
                            )}
                          </div>
                        </div>
                        <div className="wizard-form-input position-relative form-group has-float-label">
                          <div
                            className="actions "
                            style={{
                              position: "relative",
                              left: -10,
                              top: 0,
                              right: "auto",
                              bottom: "auto",
                            }}
                          >
                            <a onClick={() => pleaseChangePassword()}>
                              <ul>
                                <li>
                                  <span
                                    style={{ backgroundColor: "#546ADF" }}
                                    title="Login"
                                  >
                                    Submit
                                  </span>
                                </li>
                              </ul>
                            </a>
                          </div>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassword;
